import React from "react";
import { FormBuilder } from "../../../../components/form/FormBuilder";
import { forms } from "../../../../shared/static/forms";
import { store } from "../../../../redux/store";
import { hideModal } from "../../../../connected-components/modal/reducer";
import { addPatient } from "./actions";
import { AddPatientRequest } from "../../../../interfaces/api/patients";

const AddNewPatient: React.FC = () => {
  const handleSubmit = async (value: Record<string, any>) => {
    const patientForm = {
      ...value,
      insurance_provider: "None",
      insurance_number: "N/A",
      nssf_number: "N/A",
      ministry_health_card_number: "N/A",
      primary_language: "English",
      relationship: "Self",
      emergency_contact_name: "N/A",
      emergency_contact_phone: "N/A"
    }
    const success = await addPatient(patientForm as AddPatientRequest);
    if (success) {
      store.dispatch(hideModal());
    }
  };

  return (
    <div className="w-full pt-4">
      <FormBuilder
        schema={forms.addNewPatient}
        gridConfig={{ mobile: 1, desktop: 3 }}
        initialValues={{ insurance_provider: "None" }}
        onSubmit={handleSubmit}
      />
    </div>
  );
};

export default AddNewPatient;